__turbopack_context__.v({
  "breadcrumb": "breadcrumb-module-scss-module__pEVb_a__breadcrumb",
  "item": "breadcrumb-module-scss-module__pEVb_a__item",
  "link": "breadcrumb-module-scss-module__pEVb_a__link",
  "list": "breadcrumb-module-scss-module__pEVb_a__list",
  "separator": "breadcrumb-module-scss-module__pEVb_a__separator",
  "text": "breadcrumb-module-scss-module__pEVb_a__text",
});
